import { defineMessages } from "react-intl";

const messages = defineMessages({
    addCard: {
        id: "tasks.rhythmSorting.addCard",
    },
});

export default messages;
